<template>
    <el-dialog :custom-class="'user-dialog'" :visible="dialogvisible" width="60%" @close="$emit('update:dialogvisible', false); visiblePassword=false">
        <div class="avatar-box">
            <img :src="userdata.resim ? this.imageUrl+userdata.resim+'' : imagePlaceholder" alt="user avatar">
        </div>
        <el-tabs v-model="activeName" class="yoneticiDetay">
            <el-tab-pane :label='$t("src.views.apps.yonetici.userDialog.title")' name="first">
                <div class="flex center demo-box">
                    <div class="right-box box grow">
                        <dl class="horizontal">
                            <dt><i class="mdi mdi-account"></i>{{$t("src.views.apps.yonetici.userDialog.name")}}</dt>
                            <dd> : {{userdata.adSoyad}}</dd>
                            <!-- <el-divider></el-divider>
                            <dt><i class="mdi mdi-account-card-details"></i>T.C. No</dt>
                            <dd v-if="userdata.tcNo"> : {{userdata.tcNo}}</dd>
                            <dd v-else> : ---</dd> -->
                            <el-divider></el-divider>
                            <dt><i class="mdi mdi-email"></i>{{$t("src.views.apps.yonetici.userDialog.email")}}</dt>
                            <dd> : {{userdata.eposta}}</dd>
                            <el-divider></el-divider>
                            <!-- <dt><i class="mdi mdi-star"></i>{{$t("src.views.apps.yonetici.userDialog.task")}}</dt>
                            <dd > : {{userdata.gorev}}</dd>
                            <el-divider></el-divider> -->
                            <dt><i class="mdi mdi-phone"></i>{{$t("src.views.apps.yonetici.userDialog.telephone")}}</dt>
                            <dd> : {{userdata.cepTel}}</dd>
                            <el-divider></el-divider>
                            <dt><i class="mdi mdi-phone-classic"></i>{{$t("src.views.apps.yonetici.userDialog.sabitTelefon")}}</dt>
                            <dd> : {{userdata.sabitTel}}</dd>
                            <el-divider></el-divider>
                            <dt><i class="mdi mdi-phone"></i>{{$t("src.views.apps.yonetici.userDialog.dahili")}}</dt>
                            <dd> : {{userdata.dahiliTel}}</dd>
                        </dl>
                    </div>
                </div>
                <div v-if="root || yetkili || sifreGuncellemeYetkisi">
                    <div v-if="!visiblePassword" style="text-align: center">
                        <el-button style="margin-bottom: 10px" type="primary" v-on:click="visiblePassword=true" size="mini">
                            {{$t("src.views.apps.yonetici.userDialog.createPass")}}
                        </el-button>
                    </div>
                    <el-form v-if="visiblePassword" status-icon :rules="rules" :model="yoneticiForm" ref="yoneticiForm" class="demo-ruleForm">
                        <el-row>
                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                <el-form-item :label='$t("src.views.apps.yonetici.userDialog.password")' prop="sifre">:
                                    <el-input size="small"  type="password" v-model="yoneticiForm.sifre"></el-input>
                                    <password v-model="yoneticiForm.sifre" :strength-meter-only="true"/>
                                </el-form-item>
                            </el-col>

                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                <el-form-item :label='$t("src.views.apps.messages.enterPassAgain")' prop="sifre2">:
                                    <el-input size="small"  type="password" v-model="yoneticiForm.sifre2"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row class="col-p">
                            <el-form-item>
                                <el-button v-on:click="kaydet" size="mini" type="primary">
                                    {{$t("src.views.apps.genel.kaydet")}}
                                </el-button>&nbsp;
                                <el-button v-on:click="visiblePassword=false" size="mini">
                                    Vazgeç
                                </el-button>&nbsp;
                            </el-form-item>
                        </el-row>
                    </el-form>
                </div>
            </el-tab-pane>
            <!--<el-tab-pane v-if="root || yetkili" label="Yönetici Yetkileri" name="second">
                <el-table
                        :data="yetkiListesi"
                        style="width: 100%">
                    <el-table-column
                            prop="yetkiKodu"
                            align="center"
                            label="Yetki Kodu"
                            width="200">
                    </el-table-column>
                    <el-table-column
                            prop="aciklama"
                            align="center"
                            label="Yetki Detayı"
                            width="auto">
                    </el-table-column>
                    <el-table-column
                            style="float: right"
                            :label='$t("src.views.apps.genel.islem")'
                            align="center"
                            width="150">
                        <template slot-scope="scope">
                            <el-switch
                                    v-model="scope.row.status"
                                    v-on:change="selection=scope.row; yetkiDialogVisible=true;yet(scope.row)"
                                    active-color="#13ce66"
                                    inactive-color="#ff4949"
                                    active-value="1"
                                    inactive-value="0">
                            </el-switch>
                        </template>
                    </el-table-column>
                </el-table>
            </el-tab-pane>-->
        </el-tabs>
        <el-dialog
                :title='$t("src.views.apps.sayfa.liste.uyari")'
                :visible.sync="yetkiDialogVisible"
                append-to-body
                width="30%"
                center>
            <span>'{{selection.aciklama}}' {{$t("src.views.apps.genel.kaydetChanges")}}</span>
            <span slot="footer" class="dialog-footer">
                    <el-button icon="el-icon-check"
                               type="success"
                               size="mini"
                               @click="changeStatus(selection), yetkiDialogVisible = false"></el-button>
                    <el-button type="danger" size="mini" icon="el-icon-close"
                               @click="yetkiDialogVisible = false"></el-button>
                </span>
        </el-dialog>
    </el-dialog>

</template>

<script>
    import yoneticiService from '../WSProvider/YoneticiService'
    import Password from 'vue-password-strength-meter'
    import notification from '../notification'
    import jwt_decode from "jwt-decode"

    let base64 = require('base64_js');
    let userDataDemirag = "";
    export default {
        name: 'UserDialog',
        components: {Password},
        props: ['userdata', 'dialogvisible'],
        data() {
            var validatePass = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('Please Enter Password'));
                } else {
                    if (this.yoneticiForm.sifre2 !== '') {
                        this.$refs.yoneticiForm.validateField('sifre2');
                    }
                    callback();
                }
            };
            var validatePass2 = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('Lütfen Şifreyi Tekrar Giriniz'));
                } else if (value !== this.yoneticiForm.sifre) {
                    callback(new Error('Şifreler Aynı Değil!'));
                    return;
                } else {
                    callback();
                }
            };
            return {
                selection: '',
                personel: this.userdata,
                modulListesi: [],
                yetkiListesi: [],
                activeName: 'first',
                imageUrl: yoneticiService.imagePath,
                imagePlaceholder: 'data:image/jpeg;base64,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',
                yoneticiForm: {
                    sifre: '',
                    sifre2: ''
                },
                updateData: [],
                rules: {
                    sifre: [
                        {validator: validatePass, trigger: 'blur'}
                    ],
                    sifre2: [
                        {validator: validatePass2, trigger: 'blur'}
                    ]
                },
                visiblePassword: false,
                yetkiDialogVisible: false,
                root: false,
                yetkili: false,
                sifreGuncellemeYetkisi: false
            }

        },
        mounted() {
            let self = this;

            if (localStorage.getItem("userDataDemirag")) {
                userDataDemirag = jwt_decode(localStorage.getItem("userDataDemirag"));
                if (userDataDemirag["yetkiTuru"]) {
                    if (userDataDemirag["yetkiTuru"] === '1') {
                        self.root = true;
                        self.sifreGuncellemeYetkisi = true;
                    }
                    if (userDataDemirag["yetkiTuru"] === '2') {
                        self.root = true;
                        self.sifreGuncellemeYetkisi = true;
                    }
                }
            }
        },
        methods: {
            yet(selection) {
                if (selection.status === '0') {
                    selection.status = '1';
                } else if (selection.status === '1') {
                    selection.status = '0';
                }
            },
            changeStatus(selection) {
                if (selection.status === '0') {
                    selection.status = '1';
                } else if (selection.status === '1') {
                    selection.status = '0';
                }
                yoneticiService.yetkiAtama(this.personel.yonetimKodu, selection.yetkiKodu, selection.status).then((response) => {
                    if (response.status === 200) {
                        notification.Status('success', this, 'Yetki değişikliği başarıyla gerçekleşti.')
                    } else
                        notification.Status(response.status, this);
                })
            },
            kaydet() {
                yoneticiService.yoneticiSifreGuncelle(this.userdata.yoneticiAdi ,this.yoneticiForm.sifre).then((response) => {
                    if (response.status === 200) {
                        notification.Status('success', this, 'Şifre Güncellendi..');
                        this.$emit('update:dialogvisible', false);
                    }
                    else if(response.status === 401){
                        notification.Status("warning", this, "Oturum süreniz sona ermiştir.Tekrar giriş yapınız.")
                        EventBus.$emit("userLogout", true)
                    }
                    else if(response.status === 403){
                        notification.Status("warning", this, "Bu işlem için yetkiniz bulunmamaktadır.")
                    }
                })
            }
        }
    }
</script>

<style lang="scss">
    @import '../assets/scss/_variables';

    dl i {
        color: $color-first;
        margin: 0 10px;
    }

    dl.horizontal dt {
        text-align: left;
        width: 36%;
    }

    .el-dialog.user-dialog {
        /*max-width: 500px !important;*/
    }

    .form-box .el-form div {
        margin: 20px 0;
    }

    .form-box .el-form i {
        font-size: 20px;
    }

    .el-dialog.user-dialog {
        /*max-width: 400px;*/

        .el-dialog__header {
            padding: 0;

            .el-dialog__headerbtn {
                z-index: 1;
                background: rgba(0, 0, 0, 0.05);
                min-width: 18px;
                min-height: 18px;
                border-radius: 4px;

                .el-dialog__close {
                    color: $background-color;
                }
            }
        }

        .el-dialog__body {
            padding: 0;
        }

        .avatar-box {
            background: $text-color-accent;
            margin-bottom: 10px;
            position: relative;
            

            img {
                width: 100px;
                height: 100px;
                border-radius: 50%;
                position: relative;
                bottom: -30px;
                display: block;
                margin: 0 auto;
                background: white;
                border: 2px solid $text-color-accent;
                box-sizing: border-box;
                
            }

        }

        .form-box {
            padding: 20px;
            box-sizing: border-box;

            & > * {
                margin: 10px 0;
            }
        }
    }
</style>
